
import AccountForm from "@/components/account/login/AccountForm.vue";
import BaseSpinner from "@/components/base/BaseSpinner.vue";
import BookingHeader from "@/components/bookingflow/BookingHeader.vue";
import PassengerDetails from "@/components/bookingflow/steps/passengerdetails/PassengerDetails.vue";
import useAccountPages from "@/composables/useAccountPages";
import usePassengerDetailPages from "@/composables/usePassengerDetailPages";
import { Component } from "@/models/enums";
import { useUserStore } from "@/store/user";
import { computed, defineComponent, onMounted, ref } from "vue";

export default defineComponent({
	components: {
		BookingHeader,
		AccountForm,
		BaseSpinner,
		PassengerDetails,
	},
	setup() {
		const { activeComponent } = usePassengerDetailPages();
		const userStore = useUserStore();
		const { isLoggedIn } = useAccountPages();
		const getIsLoggedIn = computed(() => userStore.getIsLoggedIn);
		const activeComponentRef = ref();
		const isLoading = ref<boolean>(true);

		const loading = computed(() => {
			return activeComponentRef.value?.loading || isLoading.value;
		});

		const component = computed(() => {
			if (!getIsLoggedIn.value) {
				return Component[Component.AccountForm];
			} else {
				return activeComponent.value ?? Component[Component.PassengerDetails];
			}
		});
		
		onMounted(() => {
			if (getIsLoggedIn.value) {
				isLoggedIn().finally(() => (isLoading.value = false));
			} else {
				isLoading.value = false;
			}
		});

		return { component, isLoading, activeComponentRef, loading };
	},
});
